import { render, staticRenderFns } from "./OrganInfoEdit.vue?vue&type=template&id=fdbb10ae&scoped=true"
import script from "./OrganInfoEdit.vue?vue&type=script&lang=js"
export * from "./OrganInfoEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdbb10ae",
  null
  
)

export default component.exports